import { render, staticRenderFns } from "./gb-whatsapp-web.vue?vue&type=template&id=b53331c8&scoped=true"
import script from "./gb-whatsapp-web.vue?vue&type=script&lang=js"
export * from "./gb-whatsapp-web.vue?vue&type=script&lang=js"
import style0 from "./gb-whatsapp-web.vue?vue&type=style&index=0&id=b53331c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b53331c8",
  null
  
)

export default component.exports